import { Autocomplete, SxProps, TextField } from '@mui/material'
import { FC } from 'react'
import { AccountCategory } from '../../../../generated'
import { enumToLabel } from '../../../utils'

interface AccountCategoryDropdownProps {
  sx?: SxProps
  value: AccountCategory | null
  onChange: (event: AccountCategory | null) => void
}

const options = Object.values(AccountCategory)

const AccountCategoryDropdown: FC<AccountCategoryDropdownProps> = ({ value, onChange, sx }) => {
  return (
    <Autocomplete
      sx={sx}
      options={options}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={option => enumToLabel(option)}
      isOptionEqualToValue={(option, value) => option === value}
      renderInput={params => <TextField {...params} label="Account Type" />}
    ></Autocomplete>
  )
}

export default AccountCategoryDropdown
